export enum TimeSlot {
  AM = 'AM',
  PM = 'PM',
  N = 'N',
  AllDay = 'All Day',
}
